module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-detail"
  }, [_c('el-row', {
    staticClass: "tool-bar"
  }, [(_vm.depPermission) ? _c('el-button', {
    staticClass: "base-btn add-btn",
    staticStyle: {
      "width": "120px"
    },
    on: {
      "click": _vm.showDialog
    }
  }, [_vm._v("\n            加入主題\n            "), _c('img', {
    staticClass: "add-icon",
    attrs: {
      "src": require("../../assets/icon/ic_add.png"),
      "alt": "A"
    }
  })]) : _vm._e(), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sels.length > 0),
      expression: "sels.length > 0"
    }],
    staticClass: "fn-btn delete-btn",
    on: {
      "click": _vm.deleteCourses
    }
  }, [_vm._v("刪除\n            "), _c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": require("../../assets/icon/ic_delete_white.png"),
      "alt": "D"
    }
  })])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "page-bar"
  }, [_c('div', {
    staticClass: "total-results"
  }, [_vm._v(" " + _vm._s(_vm.totalResult) + " ")]), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "prev-text": "prev",
      "next-text": "next",
      "current-page": this.$store.state.course.listStatus.currentPage,
      "page-size": this.$store.state.course.listStatus.pageSize,
      "total": this.$store.state.course.listStatus.total
    },
    on: {
      "current-change": _vm.course_current_change
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "min-width": "100%"
    },
    attrs: {
      "data": _vm.courses,
      "empty-text": "暫無數據"
    },
    on: {
      "selection-change": _vm.selsChange,
      "sort-change": _vm.sortChange,
      "row-click": _vm.rowClick
    }
  }, [(_vm.depPermission) ? _c('el-table-column', {
    attrs: {
      "min-width": "3%",
      "type": "selection"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.depPermission) ? _c('el-table-column', {
    attrs: {
      "min-width": "14%",
      "prop": "code",
      "label": "編號",
      "sortable": "custom"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    staticClass: "title-column",
    attrs: {
      "min-width": "33%",
      "prop": "title",
      "label": "主題",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "23%",
      "prop": "department",
      "label": "部門",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "13%",
      "prop": "category",
      "label": "分類",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "13%",
      "prop": "level",
      "label": "程度",
      "formatter": _vm.formatLevel,
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "13%",
      "prop": "type",
      "label": "類型",
      "formatter": _vm.formatType
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "19%",
      "prop": "rating",
      "label": "評分",
      "sortable": "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.courses[scope.$index].rating > 0) ? _c('StarRating', {
          attrs: {
            "rating": _vm.courses[scope.$index].rating,
            "text-class": "star-rating",
            "max-rating": 5,
            "star-size": 16,
            "read-only": true,
            "increment": 0.1
          }
        }) : _c('StarRating', {
          attrs: {
            "rating": _vm.courses[scope.$index].rating,
            "show-rating": false,
            "text-class": "star-rating",
            "max-rating": 5,
            "star-size": 16,
            "read-only": true,
            "increment": 0.1
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "16%",
      "prop": "mtime",
      "label": "更新時間",
      "formatter": _vm.formatMtime,
      "sortable": "custom"
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "加入主題",
      "show-close": false,
      "visible": _vm.dialogFormVisible,
      "customClass": "dialogWidth"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.dialogTitle,
      "prop": "id"
    }
  }, [_c('el-autocomplete', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "popper-class": "course-autocomplete",
      "custom-item": "autocomplete-item",
      "fetch-suggestions": _vm.querySearchAsync,
      "placeholder": "主題名稱/編號"
    },
    on: {
      "select": _vm.handleSelect
    },
    model: {
      value: (_vm.form.resourceTitle),
      callback: function($$v) {
        _vm.$set(_vm.form, "resourceTitle", $$v)
      },
      expression: "form.resourceTitle"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addCourse
    }
  }, [_vm._v("加入" + _vm._s(_vm.typeString) + " ")])], 1)], 1), _vm._v(" "), _c('hint', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hint.display && this.$store.state.hintStatus.table),
      expression: "hint.display && this.$store.state.hintStatus.table"
    }],
    attrs: {
      "message": _vm.hint.message
    },
    on: {
      "close": _vm.closeHint
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ef2d116"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav1/CourseType.vue
// module id = 895
// module chunks = 170